import React from 'react';
import { Link } from 'react-router-dom';
import { UdvegaLogo } from '../components/UdvegaLogo';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 py-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <UdvegaLogo dark size="md" />
            <p className="text-sm text-slate-400 mt-3">
              Predicting Burnout. Preserving Sanity.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-medium text-white mb-3 text-sm">Platform</h4>
            <div className="flex flex-col gap-2">
              <Link to="/solutions" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">Solutions</Link>
              <Link to="/success-stories" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">Success Stories</Link>
              <Link to="/about" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">About Us</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-medium text-white mb-3 text-sm">Resources</h4>
            <div className="flex flex-col gap-2">
              <Link to="/pricing" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">Pricing</Link>
              <Link to="/faq" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">FAQ</Link>
              <Link to="/contact" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">Contact</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-medium text-white mb-3 text-sm">Legal</h4>
            <div className="flex flex-col gap-2">
              <Link to="/terms" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">Privacy Policy</Link>
              <Link to="/gdpr" className="text-sm text-slate-400 hover:text-teal-400 transition-colors">GDPR Compliance</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">&copy; 2026 Udvega. All rights reserved.</p>
          <p className="text-xs text-slate-500">ISO 27001 Certified · GDPR Compliant · SOC 2 Type II</p>
        </div>
      </div>
    </footer>
  );
}
